import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import Sidebar from '../../includes/Sidebar';
import { Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { FaShieldHalved, FaCodeBranch, FaCartShopping, FaCircleCheck } from "react-icons/fa6";
import { IoMdHeartEmpty, IoMdHeart } from "react-icons/io";
import { ListWishlist, RemoveWishlist, postStoreCart, AddWishlist, RemoveCart } from '../../apiservices/ApiServices';
import { useCartWishlist } from '../CartWishlistContext';

const Wishlist = () => {
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [ismsg, setisMsg] = useState(false);
    const [wishlistsTot, setWishlistsTot] = useState(1);
    const { cart, setCart, addToCart, removeWishlist, addToWishlist } = useCartWishlist();
    const navigate = useNavigate();

    const getListWishlist = async () => {
        setLoading(true);
        try {
            const res = await ListWishlist();
            setData(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setisMsg(true);
            setData([]);
        }
        setWishlistsTot(wishlistsTot + 1);
    };

    const handleRemove = async (skuid) => {
        setLoading(true);
        removeWishlist(skuid);
        setTimeout(() => {
            getListWishlist();
            setWishlistsTot(wishlistsTot + 1);
        }, 2000);

    };



    const removeCartData = async (id) => {
        try {
            const res = await RemoveCart(id);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (!localStorage.getItem('userToken')) {
            navigate("/");
        }
        else {
            if (localStorage.getItem('wSkuid')) {
                let skuid = localStorage.getItem('wSkuid');
                setLoading(true);

                try {
                    const res = AddWishlist({ sku_id: skuid });
                    setTimeout(() => {
                        getListWishlist();
                    }, 3000);

                } catch (error) {
                    getListWishlist();
                }
            }
            else {
                getListWishlist();
            }

            const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
            setCart(storedCart);
        }

    }, []);

    return (
        <>
            <Header CartTot={cart.length} WishTot={wishlistsTot} toast={toast} />
            <ToastContainer />
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="crumbsec">
                        <div className="wrap">
                            <Link to={'/'}>Home</Link>
                            <span className="sep">&rsaquo;</span>
                            <Link to={'/profile'}>My Account</Link>
                            <span className="sep">&rsaquo;</span>
                            <span className="cur">Wishlist</span>
                        </div>
                    </div>

                    <section className="page-hero cart-hero">
                        <Container>
                            <div className="page-wrap hero-inner">
                                <div className="hero-title">
                                    <span className="hero-icon"><IoMdHeart /></span>
                                    <div>
                                        <h1>Wishlist</h1>
                                        <p>Review your items and proceed to checkout securely.</p>
                                    </div>
                                </div>
                                <div className="hero-perks">
                                    <div className="hero-perk"><FaShieldHalved /><span><b>1-Year Warranty</b>on Premium Products</span></div>
                                    <div className="hero-perk"><FaCodeBranch /><span><b>2 Free Replacements</b>on Premium Shield</span></div>
                                    <div className="hero-perk"><FaShieldHalved /><span><b>Secure Checkout</b>100% Safe &amp; Trusted</span></div>
                                </div>
                            </div>
                        </Container>
                    </section>

                    <main className="main" style={{ paddingBottom: '50px' }}>
                        <Container>
                            <div className="layout">
                                <Sidebar />
                                <section className="content">
                                    {ismsg ? (
                                        <div className='nodata'>
                                            <h2>Wishlist is Empty</h2>
                                            <div className='buttonbox'>
                                                <Link className='btn btn-green' to={'/product'}>Back to shopping</Link>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className='cardlist'>
                                                {data.map((item) => {
                                                    return (
                                                        <div className='cards' key={item.product_id}>
                                                            <div className='cardsdetails'>
                                                                <div className='productimg'>
                                                                    <Link to={`/product/${item.slug}`}><img src={item?.media_list[0]?.media_url} alt='' title='' /></Link>
                                                                </div>
                                                                <div className='product-contnet'>
                                                                    {item?.eligible_plan_name != '' && (<h4 className={`planstitle ${item?.eligible_plan_name}`}>{item?.eligible_plan_name}</h4>)}
                                                                    <Link to={`/product/${item.slug}`}><h4>{item.name}</h4></Link>
                                                                    <div className='bandModal'>
                                                                        <p>{item?.brands?.name} {item?.model?.name}</p>
                                                                    </div>
                                                                    <div>
                                                                        <span className="pprice">&#8377;{item.price}</span>
                                                                        <span className="pold">&#8377;{item.actual_price}</span>
                                                                    </div>
                                                                    {item?.thumbnail_description != '' && (<p className='planContents'>{item?.thumbnail_description}</p>)}
                                                                </div>
                                                            </div>
                                                            <div className='cardsqty'>
                                                                {item.quantity === 0 ? <div className='outofstock'>Out of Stock</div> : (
                                                                    <>
                                                                        {cart.some(items => items.sku_id == item.sku_id) ?
                                                                            <Link to={'/cart'} className='btn btn-link'>Go to Cart</Link> :
                                                                            <button className='btn btn-link' onClick={() => addToCart(item.sku_id)}>Add to Cart</button>
                                                                        }
                                                                    </>
                                                                )}
                                                                <button className='btn btn-link text-red' style={{ marginLeft: 15 }} onClick={() => handleRemove(item.sku_id)}>Remove</button>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </>
                                    )}
                                </section>
                            </div>
                        </Container>
                    </main>
                </>
            )}

            <Footer toast={toast} />
        </>
    )
}

export default Wishlist;